'use client';

import { useRouter, usePathname } from 'src/navigation';
import styles from './gallery-viewer.module.scss';
import React from 'react';
import { useState } from 'react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import Subsection from 'components/containers/sub-section';
import LoadingIcon from 'assets/icons/loading-spinner.svg';
import LegacyOrMarkdownParser from 'components/rich-text/legacy-or-markdown-parser';

const GalleryViewer = ({ gallerySvg }: props) => {
	const [mouseDownCase, setMouseDownCase] = useState(null);
	const [loading, setLoading] = useState(null);
	const router = useRouter();
	const pathname = usePathname();

	const handleMouseDown = (e: React.MouseEvent<Element, MouseEvent>) => {
		const caseEl = (e.target as Element).closest('.case');
		if (caseEl) {
			setMouseDownCase(caseEl.id);
		}
	};

	const handleMouseUp = (e: React.MouseEvent<Element, MouseEvent>) => {
		const caseEl = (e.target as Element).closest('.case');
		if (caseEl && caseEl.id == mouseDownCase) {
			router.push(`${pathname}/case/${caseEl.id}`, { scroll: false });
			setLoading(true);
		}
	};

	return (
		<>
			<Subsection>
				<h3>Find on map</h3>
				The display cases in the gallery are shown in the map below. Pinch or
				scroll to zoom and select a case for more information.
			</Subsection>
			{loading && (
				<div className={styles.loadingScrim}>
					<LoadingIcon />
				</div>
			)}
			<div
				onMouseDown={handleMouseDown}
				onMouseUp={handleMouseUp}
				className={styles.map}
			>
				<TransformWrapper
					disablePadding={true}
					maxScale={5}
					wheel={{ smoothStep: 0.01 }}
					pinch={{ step: 0.2 }}
				>
					<TransformComponent wrapperClass={styles.wrapper}>
						<div className={styles.svgWrapper}>
							<LegacyOrMarkdownParser>{gallerySvg}</LegacyOrMarkdownParser>
						</div>
					</TransformComponent>
				</TransformWrapper>
			</div>
		</>
	);
};

interface props {
	gallerySvg: string;
}

export default GalleryViewer;
